import type { CompleteFieldSelector } from '@/types/fields-api.model';
import { Match } from '@/types/tournament.model';
import { SPORT_FIELDS } from '../sport/sport-fields.config';
import { TEAM_FIELDS } from '../team/team-fields.config';
import { CLUB_FIELDS } from '../clubs/clubs-fields.config';

const MATCH_FIELDS_MINIMAL = {
  id: true,
  team1: TEAM_FIELDS.FULL,
  team2: TEAM_FIELDS.FULL,
  startDate: true,
  endDate: true,
};

const MATCH_FIELDS_FULL: CompleteFieldSelector<Match> = {
  ...MATCH_FIELDS_MINIMAL,
  competitiveMatchType: true,
  club: CLUB_FIELDS.FULL,
  location: true,
  createdBy: true,
  category: {
    id: true,
    name: true,
    minimumElo: true,
    sport: SPORT_FIELDS.FULL,
  },
  result: {
    team1Score: true,
    team2Score: true,
    isValid: true,
    sportType: true,
    setScores: {
      team1Games: true,
      team2Games: true,
    },
    team1PenaltyScore: true,
    team2PenaltyScore: true,
    team1Walkover: true,
    team2Walkover: true,
  },
  playersPerTeam: true,
  sport: SPORT_FIELDS.FULL,
  matchType: true,
  gender: true,
  scheduled: true,
  pendingReschedule: true,
  conflict: true,
  conflictMissingAvailability: true,
  forcedReason: true,
  // Carries the DEPENDENT_MATCH marker used to label placeholder teams in the group stage.
  description: true,
};

export const MATCH_FIELDS = {
  MINIMAL: MATCH_FIELDS_MINIMAL,
  FULL: MATCH_FIELDS_FULL,
} as const;

// Narrow on purpose: the backend default would serialize full user DTOs.
export const ORGANIZED_MATCH_FIELDS = {
  id: true,
  startDate: true,
  endDate: true,
  playersPerTeam: true,
  matchType: true,
  gender: true,
  notes: true,
  activeChargeAmount: true,
  // Without it the backend cannot convert dates and falls back to UTC.
  timezone: true,
  sport: { uid: true, name: true },
  category: { id: true, name: true },
  createdBy: { email: true, name: true },
  team1: { players: { email: true, name: true } },
  team2: { players: { email: true, name: true } },
} as const;
